import React from 'react';
import ListSubMenu from './ListSubMenu';

export default function ChildMenus(data) {

   if (null == data.submenu) {
       return ("");
   } else {
       return (
           <ul className="show-dropdown">
               {data.submenu.map((item, index) => (
                   <ListSubMenu item={item} />
               ))}
           </ul>
       )
   }
}
